import React, { useState } from "react";
import ProfitLossForm from "./ProfitLossForm";
import DerivativePLForm from "./DerivativePLForm";
import BonusForm from "./BonusForm";
import { Receipt, Layers, Sparkles } from "lucide-react";

export default function PnlTabs() {
  const [tab, setTab] = useState("equity");

  const tabs = [
    { id: "equity", label: "Equity P&L Statement", icon: Receipt },
    { id: "derivative", label: "Derivative P&L Statement", icon: Layers },
    { id: "bonus", label: "Bonus", icon: Sparkles },
  ];

  return (
    <div data-testid="pnl-tabs">
      <div className="flex gap-2 mb-5 flex-wrap">
        {tabs.map((t) => {
          const active = tab === t.id;
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`pnl-tab-${t.id}`}
              className={`flex items-center gap-2 px-4 h-10 rounded-md text-xs font-medium border whitespace-nowrap transition-colors ${
                active
                  ? "bg-emerald-500 text-slate-950 border-emerald-500"
                  : "bg-slate-900 text-slate-400 border-slate-800 hover:text-white"
              }`}
            >
              <Icon size={14} />
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "equity" && <ProfitLossForm />}
      {tab === "derivative" && <DerivativePLForm />}
      {tab === "bonus" && <BonusForm />}
    </div>
  );
}
